import { DeleteOutlined, EditOutlined, PlusOutlined } from "@ant-design/icons";
import { Button, Flex, Modal, Spin, Tooltip, Typography } from "antd";
import { useForm } from "antd/lib/form/Form";
import _ from "lodash";
import React, { useState } from "react";
import { ContentPartFilter } from "../../../../components/content-part/ContentPartFilter";
import { PageHeader } from "../../../../components/page-header";
import { EmptyData } from "../../../../components/empty/emptyData";
import { AddTransportModal } from "./AddTransport";
import { useTransport } from "./useTransport";
import { FilterTransport } from "./FilterTransport";
import { EntTransportFilter } from "../../../../models/filters/transportFilter";
import { useTranslation } from "react-i18next";
import { useGetDataOnScroll } from "../../../../components/getDataOnScrollProps/useGetDataOnScrollProps";
import i18n from "i18next";
import { EntTransport } from "../../../../models/transport";
import {
  useGetReportTransportMutation,
  useGetReportWorkTransportMutation,
  useLazyGetTransportListAllQuery
} from "../../../../redux/api/transport/transportApi";
import ReportTransportModal from "./ReportTransportModal";

enum FormField {
  periodStart,
  periodEnd,
  territorialUnitId
}

export const TransportRegister = () => {
  const [modal, contextHolder] = Modal.useModal();
  const [selectedItem, setSelectedItem] = useState<EntTransport>(new EntTransport());
  const [showModal, setShowModal] = useState<boolean>(false);
  const [showReportModal, setShowReportModal] = useState<boolean>(false);
  const [reportType, setReportType] = useState<'transportAll'|'transportWork'|null>(null);
  const [form] = useForm();
  const { t } = useTranslation();

  const [getTransportReportWork] = useGetReportWorkTransportMutation();
  const [getTransportReport] = useGetReportTransportMutation();
  const [getTransportFolders] = useLazyGetTransportListAllQuery();
  const {
	filter,
	fetching,
	data,
	access,
	totalItems,
	setData,
	setFetching,
	setFilter,
	scrollHandler,
	setCurrentPage
  } = useGetDataOnScroll<EntTransport, EntTransportFilter>({
	initialFilter: new EntTransportFilter(),
	query: getTransportFolders
  });

  const { onAddTransport, onEditTransport, onDeleteTransport } = useTransport(modal, () => {
	searchHandleClick();
  })
  const [height, setHeight] = useState<number>(0);

  const storedData = JSON.parse(localStorage.getItem("availableRoutes") || "[]");
  const isMechAvailable = storedData.some((route: any) => (route.alias === "/departments/mechanization/report" || route.alias === "/interactive-map-ws") && route.methodPost);

  const openAddModal = (item: EntTransport) => {
	setSelectedItem(item);
	setShowModal(true);
  }

  const setEntityFromFields = (): EntTransportFilter => {
	let filt: EntTransportFilter = _.clone(filter);
	filt.periodStart = form.getFieldValue(FormField.periodStart)?.format("YYYY-MM-DD") ?? null;
	filt.periodEnd = form.getFieldValue(FormField.periodEnd)?.format("YYYY-MM-DD") ?? null;
	filt.territorialUnitId = form.getFieldValue(FormField.territorialUnitId) ?? null;
	filt.page = 1;
	return filt;
  }

  const clearFields = () => {
	form.setFields([
	  { name: FormField.periodStart, value: null },
	  { name: FormField.periodEnd, value: null },
	  { name: FormField.territorialUnitId, value: null },
	]);
  }

  const searchHandleClick = () => {
	setFilter(setEntityFromFields());
	setData([]);
	setCurrentPage(0);
	setFetching(true);
  }

  const getReportAll = async (payload: { manufactureYear: number; }): Promise<Blob> => {
	return await getTransportReport({ ...payload, language: i18n.language }).unwrap();
  };

  const getReportWork = async (payload: {
	manufactureYear: number;
	seasonStatus?: boolean|null;
	checkStatus?: boolean|null;
  }): Promise<Blob> => {
	return await getTransportReportWork({ ...payload, language: i18n.language }).unwrap();
  };

  const openReportModal = (type: 'transportAll'|'transportWork') => {
	setReportType(type);
	setShowReportModal(true);
  };

  const table = (
	<div style={ { maxHeight: `${ height }px`, overflow: 'auto', maxWidth: 450 } } onScroll={ scrollHandler }>
	  <table>
		<thead>
		<tr>
		  <th style={ { width: "40px" } }>#</th>
		  <th>{ t('general.territorial_unit') }</th>
		  <th style={ { width: "120px" } }></th>
		</tr>
		</thead>
		<tbody>
		{ fetching ?
		  <tr>
			<th colSpan={ 5 }>
			  <Spin spinning={ fetching } style={ {
				width: '100%',
				height: '180px',
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'center'
			  } }/>
			</th>
		  </tr>
		  : <></> }
		{ data.length !== 0 ? data.map((item, index) => (
		  <tr key={ item.id }>
			<td>{ ++index }</td>
			<td>{ i18n.language === 'ru' ? item?.territorialUnit?.nameRu : item?.territorialUnit?.nameKy }</td>


			<td>
			  <Flex gap="small">
				{ access && access.methodPut && (
				  <Tooltip title={ t('general.edit') }>
					<Button className='btn_edit' onClick={ () => {
					  openAddModal(item)
					} } type="primary" shape="circle" icon={ <EditOutlined/> }/>
				  </Tooltip>
				) }
				{ access && access.methodDelete && (
				  <Tooltip title={ t('general.delete') }>
					<Button className='btn_edit' danger onClick={ () => {
					  onDeleteTransport(item)
					} } type="primary" shape="circle" icon={ <DeleteOutlined/> }/>
				  </Tooltip>
				) }
			  </Flex>
			</td>
		  </tr>
		)) : <tr>
		  <td colSpan={ 5 }>
			<EmptyData/>
		  </td>
		</tr> }
		</tbody>
	  </table>
	</div>
  );

  return (
	<>
	  <PageHeader
		title={ t('mechanisation.transport.register_trans_dep_mech') }
		additionalInfo={
		  <Typography.Text style={ { marginBottom: '0.5em', display: 'block' } } type="secondary">
			{ t('general.records_found') } { totalItems }</Typography.Text>
		}/>
	  { access && access.methodPost && (
		<Button type="primary" icon={ <PlusOutlined/> } onClick={ () => {
		  openAddModal(new EntTransport())
		} }>
		  { t('general.add') }
		</Button>
	  ) }
	  { isMechAvailable && (
		<>
		  <Button
			style={ { marginLeft: '5px' } }
			type="primary"
			icon={ <PlusOutlined/> }
			onClick={ () => openReportModal('transportAll') }
		  >
			{ t('reports.report_by_transport_all') }
		  </Button>
		  <Button
			style={ { marginLeft: '5px' } }
			type="primary"
			icon={ <PlusOutlined/> }
			onClick={ () => openReportModal('transportWork') }
		  >
			{ t('reports.report_by_transport_work') }
		  </Button>
		</>
	  ) }
	  <ContentPartFilter
		filter={ <FilterTransport onSearch={ searchHandleClick }
								  onReset={ () => {
									clearFields();
									searchHandleClick()
								  } } formField={ FormField } form={ form }/> }
		setHeight={ setHeight }
		table={ table }
	  />
	  <AddTransportModal
		transport={ selectedItem }
		show={ showModal }
		onHide={ () => {
		  setShowModal(false)
		} }
		onSubmit={ selectedItem.id !== null ? onEditTransport : onAddTransport }
	  />
	  <ReportTransportModal
		title={ reportType === 'transportAll' ? t('reports.report_by_transport_all') : t('reports.report_by_transport_work') }
		type={ reportType }
		getReport={ reportType === 'transportAll' ? getReportAll : getReportWork }
		show={ showReportModal }
		onHide={ () => setShowReportModal(false) }
	  />
	  { contextHolder }
	</>
  )
}
